<template>
  <SideModal
    :show="school && show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="right"
    close-on-overlay-click
  >
    <form @submit.prevent="save" class="modal-container">
      <div class="modal-top">
        <span class="d-flex gap-3 align-center">
          <Typography color="primary" weight="600" size="1.25rem">Edit School</Typography>
          <v-icon size="x-small" @click="copyToClipboard(school.uid)">mdi-content-copy</v-icon>
        </span>
        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <div class="modal-body">
        <div><Autocomplete
              :max-items="50"
              label="District"
              :loading="schoolStore.districts.loading"
              v-model="school.district_id"
              :items="schoolStore.districts.data"
              item-title="district_name"
              item-value="district_id"
              variant="outlined"
              class="custom-input"
              density="comfortable"
              color="primary"
              clearable
              data-cy="district-select"
              :item-props="{ 'data-cy': 'district-select-item' }"
            ></Autocomplete></div>
          <!-- <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="District Name"
            v-model="school.district.district_name"
          ></v-text-field> -->
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="School Name"
            v-model="school.school_name"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Account ID"
            v-model="school.subdomain"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="School Logout Url"
            v-model="school.school_url"
          ></v-text-field><v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Name"
            v-model="school.school_contact_name"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Email"
            v-model="school.school_contact_email"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Phone Number"
            v-model="school.school_contact_phone"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Address"
            v-model="school.school_contact_address1"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Address"
            v-model="school.school_contact_address2"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="City"
            v-model="school.school_contact_city"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="State"
            v-model="school.school_contact_state"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Zip Code"
            v-model="school.school_contact_zip"
          ></v-text-field>
          <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Country"
            v-model="school.school_contact_country"
          ></v-text-field>
          <date-picker
            color="primary"
            :model-value="new Date(school?.status.expiration_date)"
            @update:model-value="school.status.expiration_date = dayjs($event).format(`YYYY-MM-DD HH:mm:ss`)"
            class="custom-input date"
            density="compact"
            type="date"
            label="Date"
            data-cy="school-status-expiration-date"
          ></date-picker>
          <!-- <v-text-field
            :disabled="school.deleted"
            class="custom-input"
            color="primary"
            label="Integration"
            v-model="school.integration"
          ></v-text-field>
          -->

          <!-- <div>
            <v-text-field
              :disabled="school.deleted"
              class="custom-input"
              color="primary"
              label="Subdomain"
              v-model="state.subdomain"
              required
              
            ></v-text-field>
            <FormValidate
              email
              :validate="state.email"
              title="Field must be an email"
            ></FormValidate>
          </div> -->

        <div>
          <div style="display: flex; width: 100%; gap: 15px; justify-content: stretch">
            <v-btn
              v-if="!school.deleted"
              @click="setDelete(true)"
              :loading="state.loadingDelete"
              style="text-transform: capitalize; flex-grow: 1"
              color="#E5E4DB"
            >
              Delete
            </v-btn>
            <v-btn
              v-if="!school.deleted"
              type="submit"
              :loading="state.loadingSave"
              style="text-transform: capitalize; flex-grow: 1"
              >Save</v-btn
            >
            <v-btn
              v-else
              @click="setDelete(false)"
              :loading="state.loadingDelete"
              style="text-transform: capitalize; flex-grow: 1"
              >Restore</v-btn
            >
          </div>
        </div>
      </div>
    </form>
  </SideModal>
</template>

<script setup lang="ts">
import type { GetSchoolDetails, District } from "@/api_types/school";
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import DatePicker from "@/components/datePicker.vue";

import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import { cloneDeep } from "lodash";
import dayjs from "dayjs";

import { useSchools } from "@/stores/support/schools";
// import FormValidate from "@/components/formValidate.vue";
import { copyToClipboard } from "@/utils";
import Autocomplete from "@/components/autocomplete.vue";

const schoolStore = useSchools();

const props = defineProps<{
  school: GetSchoolDetails;
  show: boolean;
}>();

const state = reactive({
  loadingSave: false,
  loadingDelete: false,
  school_name: "",
  district: {
    district_name: ""
  }
});
const school = reactive(cloneDeep(props.school));

watch([() => props.school, () => props.show], () => {
  if (props.school)
    Object.assign(school, cloneDeep(props.school));
});

defineEmits<{
  (e: 'update:show', ...args: any[]): void
}>();

const save = async () => {
  state.loadingSave = true;
  console.log("saving....");
  const res = await schoolStore.updateSchool(school.school_id, school);
   useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "School Details updated successfully" : "Failed to update school details",
    7
  );

  state.loadingSave = false;
};
const setDelete = async (val: boolean) => {
  state.loadingDelete = true;
  school.deleted=val;
  const message = val ? "delete" : "restore";
  let res;
  if (val){
    res = await schoolStore.deleteSchool(school.school_id);
  }else{    
    res = await schoolStore.updateSchool(school.school_id, school);
  }
  
  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? `School ${message}d successfully` : `Failed to ${message} school`,
    7
  );

  state.loadingDelete = false;
};
 watch(()=>schoolStore.districts,()=> console.log(schoolStore.districts))
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
